<template>
  <div>
    <div class="text-right mb-2">
      <b-button
        variant="primary"
        @click="activeItemsNewItemForm()"
      >
        <FeatherIcon icon="PlusIcon" /> Ekle
      </b-button>
    </div>
    <validation-observer ref="simpleRules">
      <b-card
        v-if="itemForm"
        :title="dataItem.title ? dataItem.title : 'Yeni Öğe'"
      >
        <b-form-group
            label="Proje Grubu"
            label-for="id_product_categories"
        >
          <v-select
              id="id_product_categories"
              v-model="dataItem.id_product_reynaers_cat"
              :options="productsCat"
              label="title"
              :reduce="item => item.id"
              placeholder="Proje Grubu"
          >
            <template v-slot:option="option">
              <div>
                {{ option.title }}
              </div>
              <div>
              </div>
            </template>
            <template v-slot:selected-option="option">
              {{ option.title }}
            </template>
          </v-select>
        </b-form-group>
        <b-form-group
          label="Başlık"
          label-for="title"
        >
          <validation-provider
            #default="{ errors }"
            name="Başlık"
            rules="required"
          >
            <b-form-input
              id="title"
              v-model="dataItem.title"
              placeholder="Başlık"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group
          label="Değer"
          label-for="value"
        >
          <validation-provider
            #default="{ errors }"
            name="Değer"
            rules="required"
          >
            <b-form-input
              id="value"
              v-model="dataItem.value"
              placeholder="Değer"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-button
            variant="primary"
            class="mt-2"
            @click="submitForm"
        >
          Kaydet
        </b-button>
        <b-button
            variant="danger"
            class="mt-2 ml-2"
            @click="hideForm"
        >
          İptal
        </b-button>
      </b-card>
      <b-card
        title="Değerlerimiz"
        no-body
      >
        <b-card-header>
          <b-card-title>Liste</b-card-title>
        </b-card-header>
        <b-table
          responsive="sm"
          :fields="fields"
          :items="datalist"
          striped
        >
          <template #cell(title)="data">
            {{ data.item.title }}
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <b-dropdown
                split
                text="Güncelle"
                variant="outline-primary"
                right
                size="sm"
                @click="activeItemsForm(data.item.id)"
              >
                <template #button-content>
                  <feather-icon
                    icon="EditIcon"
                  />
                  Güncelle
                </template>
                <b-dropdown-item
                  v-if="data.item.id"
                  @click="removeItemsForm(data.item.id)"
                >
                  <feather-icon icon="XIcon" />
                  <span class="align-middle ml-50">Sil</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput, BCard, BButton, BDropdown, BCardTitle, BCardHeader, BDropdownItem, BTable,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ItemsImageCard from "@/views/Admin/Products/elements/ItemsImageCard2.vue"
import vSelect from 'vue-select'
export default {
  name: 'ItemsCard2',
  components: {
    ItemsImageCard,
    BTable,
    BDropdownItem,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BButton,
    BCard,
    BFormInput,
    BFormGroup,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    EditorToolbar,
    vSelect,
  },
  data() {
    return {
      required,
      editorOption: {
        modules: {
          toolbar: '#content_toolbar_items',
        },
        theme: 'snow',
      },
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      itemForm: false,
    }
  },
  computed: {
    datalist() {
      return this.$store.getters['productsReynaersTech/dataList']
    },
    dataItem() {
      return this.$store.getters['productsReynaersTech/dataItem']
    },
    saveData() {
      return this.$store.getters['productsReynaersTech/dataSaveStatus']
    },
    itemsProduction() {
      return this.$store.getters['products/dataItem']
    },
    productsCat() {
      return this.$store.getters['productReynaersCat/dataList']
    },
  },
  watch: {
    itemsProduction(val) {
      if (val && val.id) {
        this.getProductionItems()
      }
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getProductionItems()
        this.itemForm = false
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    localize('tr')
    this.getProductionItems()
    this.getProductCat()
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('productsReynaersTech/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
    getProductionItems() {
      return this.$store.dispatch('productsReynaersTech/getDataList', this.itemsProduction.id)
    },
    removeItemsForm(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('productsReynaersTech/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    activeItemsForm(id) {
      this.dataItem.title = null
      this.dataItem.value = null
      this.dataItem.id_product_reynaers_cat = null
      this.dataItem.id_products = this.itemsProduction.id
      this.$store.dispatch('productsReynaersTech/getDataItem', id)
      this.itemForm = true
    },
    activeItemsNewItemForm() {
      this.dataItem.id = null
      this.dataItem.title = null
      this.dataItem.value = null
      this.dataItem.id_product_reynaers_cat = null
      this.dataItem.id_products = this.itemsProduction.id
      this.itemForm = true
    },
    hideForm() {
      this.itemForm = false
    },
    getProductCat() {
      this.$store.dispatch('productReynaersCat/getDataList', {
        select: [
          'product_reynaers_cat.id AS id',
          'product_reynaers_cat.title AS title',
          'prc.title AS main_group',
        ],
        where: {
          'product_reynaers_cat.id_product_reynaers_cat !=': null,
        },
      })
    },
  },

}
</script>
